import { useMemo } from 'react';
import type { AnalyticsDataPoint } from '../../components/ChartContainer';
import { aggregateByGranularity } from '../../utils/aggregateByGranularity';

export function useSubscriptionsGained(
    map: Map<string, number> | undefined,
    granularity: 'daily' | 'weekly' | 'monthly',
): AnalyticsDataPoint[] {
    return useMemo(() => {
        if (!map) return [];
        const data = Array.from(map.entries())
            .map(([code, count]) => ({ code, value: count }))
            .sort((a, b) => new Date(a.code).getTime() - new Date(b.code).getTime());
        return aggregateByGranularity(data, granularity);
    }, [map, granularity]);
}
